<template>
  <div
    class="w-full mt-6 bg-gray-50 dark:bg-background rounded-t-[20px] flex flex-col px-4 md:px-8 gap-6 lg:gap-8 min-h-screen"
  >
    <div class="flex flex-col lg:flex-row lg:items-start w-full gap-8">
      <!-- Navigation Area -->
      <div class="w-full lg:w-32 flex-shrink-0 lg:pt-2">
        <BackButton />
      </div>

      <!-- Content Area -->
      <main class="flex-1 w-full min-w-0">
        <CreditsComponent />
      </main>
    </div>
  </div>
</template>

<script>
import CreditsComponent from "@/components/pricing/CreditsComponent.vue";
import BackButton from "@/components/BackButton.vue";

export default {
  name: "CreditsView",
  components: {
    CreditsComponent,
    BackButton,
  },
  mounted() {
    window.scrollTo(0, 0);
    this.checkForSuccessMessage();
  },
  methods: {
    checkForSuccessMessage() {
      if (this.$route.query.success === "true" && this.$route.query.message) {
        this.$emit("show-success", this.$route.query.message);

        // Clean up the URL parameters
        this.$router.replace({
          path: this.$route.path,
          query: {},
        });
      }
    },
  },
};
</script>

<style scoped></style>
